import React from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import { useAnalyticsTracking } from 'src/utils/GoogleAnalytics'
import { useGlobalContext } from 'src/stores/GlobalContext'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import UserImage from 'src/components/Elements/UserImage'
import HorizontalLine from 'src/components/Elements/HorizontalLine'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import Button from 'src/components/Elements/Button'
import settingStyles from './settingStyles.module.scss'
import variables from 'src/assets/styles/variables.module.scss'

const ProfilePage = () => {
  const { currentUser } = useGlobalContext()
  const googleTracking = useAnalyticsTracking()
  const navigate = useNavigate()

  const handleEditProfileNavigation = () => {
    googleTracking('profile_edit', 'profile_page')
    navigate('/edit-profile')
  }

  return (
    <div className={generalStyles.thirdWidth}>
      <div>
        <div
          className={classNames(
            generalStyles.flexRow,
            generalStyles.flexApart,
            generalStyles.alignTop
          )}
        >
          <div
            className={generalStyles.flexRow}
            style={{ alignItems: 'center' }}
          >
            <div
              className={settingStyles.imageContainer}
              style={{ marginRight: 22 }}
            >
              <UserImage
                dataTestId="profileHeadshot"
                photoUrl={currentUser?.photo}
                styles={settingStyles.profileImage}
                altText={`${currentUser?.first_name} ${currentUser?.last_name} Photo`}
              />
            </div>
            <div className={generalStyles.flexColumn}>
              <span data-testid="profileName" className={fontStyles.h4lsgraphik23pt}>
                {currentUser?.first_name} {currentUser?.last_name}
              </span>

              <span data-testid="profileTitle" className={fontStyles.psmalllsin08blackgraphik15pt}>
                {currentUser?.title}
              </span>
              <span data-testid="profileOrg" className={fontStyles.psmalllsin08blackgraphik15pt}>
                {currentUser?.organization_name}
              </span>
            </div>
          </div>
          <button
            data-testid="profileEditTop"
            name="Edit Profile"
            onClick={() => handleEditProfileNavigation()}
            className={settingStyles.editButtonContainer}
            data-title="Edit"
          >
            <div className={settingStyles.iconContainer}>
              <IcomoonReact
                iconSet={rebrandIconSet}
                size={24}
                icon="Controls-Edit"
              />
            </div>
          </button>
        </div>
        <div className={classNames(generalStyles.mt20, generalStyles.mb40)}>
          <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
        </div>
      </div>
      <div className={generalStyles.mt40}>
        <span className={fontStyles.pdefaultboldlsgraphik18pt}>Biography</span>
        <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
          <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
        </div>
        <span data-testid="profileBio" className={fontStyles.psmalllsin08blackgraphik15pt}>
          {currentUser?.bio || 'No bio provided'}
        </span>
      </div>
      <div className={generalStyles.mt40}>
        <span className={fontStyles.pdefaultboldlsgraphik18pt}>
          Contact Details
        </span>
        <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
          <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
        </div>
        <div>
          <span data-testid="profilePhone" className={fontStyles.psmalllsin08blackgraphik15pt}>
            Phone |{' '}
          </span>
          <span className={fontStyles.psmallboldlsin08blackgraphik15pt}>
            {currentUser?.phone}
          </span>
        </div>
        <div className={generalStyles.mt10}>
          <span data-testid="profileEmail" className={fontStyles.psmalllsin08blackgraphik15pt}>
            Email |{' '}
          </span>
          <span className={fontStyles.psmallboldlsin06slategraphik15pt}>
            {currentUser?.email}
          </span>
        </div>
      </div>
      <div className={classNames(generalStyles.mt40, generalStyles.mb20)}>
        <span className={fontStyles.pxsmallboldlsssin08blackgraphik12pt}>
          The fields below will not be shared with business card exchange or be
          viewable by other users. This information is used by event staff only.
        </span>
      </div>
      <div>
        <span className={fontStyles.pdefaultboldlsgraphik18pt}>
          Dietary Requirements
        </span>
        <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
          <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
        </div>
        <div>
          <span data-testid="profileDietaryAssignedTags" className={fontStyles.psmalllsin08blackgraphik15pt}>
            {currentUser?.dietary_assignments || 'None selected'}
          </span>
        </div>
        <div className={generalStyles.mt20}>
          <span className={fontStyles.psmallboldlsin08blackgraphik15pt}>
            Dietary Notes
          </span>
        </div>
        <div className={generalStyles.mt10}>
          <span data-testid="profileDietaryNotes" className={fontStyles.psmalllsin08blackgraphik15pt}>
            {currentUser.dietary_restrictions || 'No dietary notes added.'}
          </span>
        </div>
        <div className={generalStyles.mt20}>
          <span className={fontStyles.psmallboldlsin08blackgraphik15pt}>
            Allergies
          </span>
        </div>
        <div className={generalStyles.mt10}>
          <span data-testid="profileDietaryAllergies" className={fontStyles.psmalllsin08blackgraphik15pt}>
            {currentUser?.dietary_allergies || 'No allergies added.'}
          </span>
        </div>
      </div>
      <div className={generalStyles.mt40}>
        <span className={fontStyles.pdefaultboldlsgraphik18pt}>
          Accessibility Needs
        </span>
        <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
          <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
        </div>
        <div>
          <span data-testid="profileAccessibilityAssignments" className={fontStyles.psmalllsin08blackgraphik15pt}>
            {currentUser?.accessibity_assignments || 'None selected'}
          </span>
        </div>
        <div className={generalStyles.mt20}>
          <span className={fontStyles.psmallboldlsin08blackgraphik15pt}>
            Additional Accessibility Information
          </span>
        </div>
        <div className={generalStyles.mt10}>
          <span data-testid="profileAccessibilityBody" className={fontStyles.psmalllsin08blackgraphik15pt}>
            {currentUser?.accessibility_needs ||
              'No accessibility notes added.'}
          </span>
        </div>
      </div>
      <div
        className={classNames(
          generalStyles.mt40,
          generalStyles.pb40,
          generalStyles.flexCentered
        )}
      >
        <Button
          data-testid="profileEditBottom"
          color={'lightBase'}
          size={'med'}
          label={'Edit'}
          onClick={() => handleEditProfileNavigation()}
          style={{
            width: 70,
            height: 42,
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 13,
            paddingBottom: 13
          }}
        />
      </div>
    </div>
  )
}

export default ProfilePage
